import React, { useEffect, useState, useContext, useRef } from 'react';
import {
  TextField,
  Typography,
  Select,
  MenuItem,
  TableCell,
  FormControl,
  InputLabel,
  FormHelperText,
  Box,
} from '@mui/material';
import Button from 'components/atoms/Button/Button';
import { api } from 'api/api';
import axios from 'axios';
import { GlobalContext } from 'context/GobalState';
import { StyledDiv, StyledListItem, StyledButtonP } from './TagModal.styles';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const TagModal = ({ setActive, setTagName, getTags, skillList }) => {
  const { authToken, skill } = useContext(GlobalContext);

  const [tagname, setTagNameModal] = useState('');
  const [tagError, setTagError] = useState(false);
  const [display, setDisplay] = useState(null);
  const [tagList, setTagList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteTagName, setDeleteTagName] = useState('');
  const [deleteTagId, setDeleteTagId] = useState();
  const handleTagName = (event) => {
    setTagNameModal(event.target.value);
  };
  const handleClickOpen = (name, id) => {
    setOpen(true);
    setDeleteTagName(name);
    setDeleteTagId(id);
  };
  // funkcjonalonosc dodania tagu do listy tagow z endpointu Pawelka
  const onSubmit = () => {
    if (tagname === '') {
      setTagError(true);
    } else {
      setTagError(false);
    }

    axios
      .post(
        `${api}data/create_tag/`,
        { skill: skill, tag_name: tagname },
        {
          headers: {
            Authorization: `token ${authToken}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setTagName(tagname);
          setTagNameModal('');
          setActive(false);
          getTags();
          updateTags();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onSaveEdit = () => {
    axios
      .patch(
        `${api}data/hide_tag/`,
        { skill: skill, tag_id: deleteTagId },
        {
          headers: {
            Authorization: `token ${authToken}`,
          },
        }
      )
      .then((response) => {
        setOpen(false);
        getTags();
        updateTags();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const cancel = () => {
    setActive(false);
    setTagName('');
  };
  const updateTags = () => {
    axios
      .get(`${api}data/all_tags/`, {
        headers: {
          Authorization: `token ${authToken}`,
        },
        params: { skill: skill },
      })
      .then(({ data }) => {
        setTagList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    updateTags();
    // eslint-disable-next-line
  }, [authToken, skill]);
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ zIndex: 9999 }}
      >
        <DialogTitle id="alert-dialog-title">{'Delete tag'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete tag <strong>{deleteTagName}?</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button contained white onClick={handleClose}>
            Cancel
          </Button>
          <Button contained white onClick={() => onSaveEdit()} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <h3>Add Tag</h3>
        <FormControl error={tagError}>
          <TextField
            error={tagError}
            id="outlined-name"
            label="Tag name"
            value={tagname}
            onChange={handleTagName}
            size="small"
            sx={{ width: '90%', m: 'auto' }}
          />
          <FormHelperText>{tagError && 'Required'}</FormHelperText>
        </FormControl>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '90%',
            m: 'auto',
            mt: 2,
            height: '50vh',
            overflow: 'scroll',
            overflowX: 'hidden',
          }}
        >
          {tagList?.map((tag, index) => (
            // isEditMode && editedTag === tag ? (
            //   <div style={{ display: 'flex', flexDirection: 'row' }}>
            //     <Input value={tag} size="small" sx={{ width: '90%', m: 'auto' }} />
            //     <StyledButtonP onClick={() => onSaveEdit(index)}>Save</StyledButtonP>
            //     <StyledButtonP onClick={() => setIsEditMode(false)}>Cancel</StyledButtonP>
            //   </div>
            // ) : (
            <StyledDiv
              onMouseEnter={(e) => {
                setDisplay(index);
              }}
              onMouseLeave={(e) => {
                setDisplay(null);
              }}
              key={index}
            >
              <StyledListItem>{tag.tag_name}</StyledListItem>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                {display === index ? (
                  <>
                    {/* <StyledButtonP onClick={() => handleEditClick(tag)}>Edit</StyledButtonP> */}
                    {/* <StyledButtonP onClick={() => onSaveEdit(tag.tag_id)}>Delete</StyledButtonP> */}
                    <StyledButtonP onClick={() => handleClickOpen(tag.tag_name, tag.tag_id)}>Delete</StyledButtonP>
                  </>
                ) : (
                  ''
                )}
              </div>
            </StyledDiv>
          ))}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', mt: 2 }}>
          <Button contained white onClick={cancel} sx={{ mr: 1 }}>
            Cancel
          </Button>
          <Button contained white onClick={onSubmit} type="submit">
            Save
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default TagModal;
